import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const TableDownstreamTablesFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamTablesFilteredByColumnQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
